import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { showActionableToast } from '~commonInfra/components/ActionableMessage';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { GetServerWelcomeChannelInfoRequest, GetServerWelcomeChannelInfoResult } from '~src/home/requests/GetServerWelcomeChannelInfoRequest';
import { SetShowWelcomeScreenRequest } from '~src/home/requests/SetShowWelcomeScreenRequest';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { HomeCloseWelcomeChannel } from '../../bootstrap/redux/actions/AppActionTypes';
import { getServerWelcomeChannelInfoSucceededAction } from '../actions/HomeActions';

export function* homeCloseWelcomeChannel() {
  try {
    yield call(sendCloseWelcomeScreenRequest);
    yield call(showDismissedWelcomeChannelToast);
  }
  catch(e) {
    // TODO: Fire off a failure log, we don't want to display a toast to the user in this case.
    yield call(logHomeFailure);
  }
}

// This could be refactored to sendShowWelcomeScreenRequest(boolean) to allow showing/hiding in the future
export function sendCloseWelcomeScreenRequest(): Promise<IResult> {
  return WebHttpClient.sendRequest(new SetShowWelcomeScreenRequest({ showWelcomeScreen: false }));
}

export function showDismissedWelcomeChannelToast() {
  showActionableToast({
    testId: 'dismissed-welcome-channel-success',
    message: Messages.home_welcomeChannel_dismissed_toast(),
    actionMessage: Messages.changeSettings(),
    action: linkToMyAccountSettings
  }, ToastType.Success);
}

function linkToMyAccountSettings(): void {
  const sessionManagementService = getSessionManagementServiceInstance();
  const siteUrls = new SpacesSiteUrls({
    siteUrlName: sessionManagementService.sessionSiteUrlName(),
  });
  const link = siteUrls.userSettingsUrl(sessionManagementService.sessionUsername(), sessionManagementService.sessionUserDomainName());
  WindowLocationService.navigateTo(link);
}

export function* fetchServerWelcomeChannelInfo() {
  if (FeatureFlags.serverWelcomeChannelEnabled) {
    const result = yield call(sendGetServerWelcomeChannelInfoRequest);
    yield put(getServerWelcomeChannelInfoSucceededAction(result));
  }
}

export function sendGetServerWelcomeChannelInfoRequest(): Promise <GetServerWelcomeChannelInfoResult> {
  return WebHttpClient.sendRequest(new GetServerWelcomeChannelInfoRequest());
}

export function logHomeFailure() {
  // TODO: Will be implemented when we figure out how we want to do monitoring.
}

export function* rootHomeSaga(): SagaIterator {
  yield takeEvery(HomeCloseWelcomeChannel, homeCloseWelcomeChannel);
}
